import {CombinedState, EndpointDefinitions} from '@reduxjs/toolkit/query';

/**
 * Represents a generic Redux state structure for any RTK Query API.
 * This extends directly from RTK Query's internal types for maximum compatibility.
 *
 * @template TDefinitions The type of endpoint definitions
 * @template TTagTypes The type of cache tags used
 * @template TReducerPath The reducer path where the API slice is mounted
 */
export type GenericRTKQState<
  // eslint-disable-next-line -eslint/no-explicit-any
  TDefinitions extends EndpointDefinitions = any,
  TTagTypes extends string = string,
  // eslint-disable-next-line -eslint/no-explicit-any
  TReducerPath extends string = any,
> = CombinedState<TDefinitions, TTagTypes, TReducerPath> & {
  _meta?: Record<string, unknown>;
};
